/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CounselingDto } from '../../models/counseling-dto';

export interface CounselingControllerFindByChildId$Params {
  centerChildId: string;
}

export function counselingControllerFindByChildId(http: HttpClient, rootUrl: string, params: CounselingControllerFindByChildId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CounselingDto>>> {
  const rb = new RequestBuilder(rootUrl, counselingControllerFindByChildId.PATH, 'get');
  if (params) {
    rb.query('centerChildId', params.centerChildId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CounselingDto>>;
    })
  );
}

counselingControllerFindByChildId.PATH = '/api/counseling';
